import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import disposable from "../assets/disposable.png";
import SummaryApi from "../common/index"; 
// Import Swiper React components and styles
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Disposable = () => {
  const [activeFlexPath, setActiveFlexPath] = useState("/products"); // Default fallback

  useEffect(() => {
    const fetchAndFindProduct = async () => {
      try {
        const res = await fetch(SummaryApi.getActiveProduct.url);
        const result = await res.json();
        
       if (result.status && result.data) {
  const product = result.data.find(p => {
    const title = p.product_title?.toLowerCase() || "";
    // Matches "disposable" AND ("panty" OR "panties")
    return title.includes("disposable") && 
          (title.includes("panty") || title.includes("panties"));
  });

          if (product) {
            // Encode the ID using btoa just like in your Products page
            const encodedId = window.btoa(product.product_id.toString());
            setActiveFlexPath(`/product/${encodedId}`);
          }
        }
      } catch (error) {
        console.error("Error finding Disposable Period Panties product:", error);
      }
    };

    fetchAndFindProduct();
  }, []);
  const features = [
    {
      title: "Built For Heavy Flow Days",
      desc: "High-absorbency protection designed for overnight comfort and long-hour wear.",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
      ),
    },
    {
      title: "Seamless Body Fit",
      desc: "Flexible 360° stretch design that adapts naturally to your body.",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
      ),
    },
    {
      title: "Breathable Comfort Fabric",
      desc: "Soft, airy materials designed to help reduce heat and moisture buildup.",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
      ),
    },
    {
      title: "Skin-Conscious Materials",
      desc: "Made without added chlorine, fragrances, or harsh bleaching agents.",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
      ),
    },
    {
      title: "Full Coverage Security",
      desc: "Front-to-back leak protection designed for extra confidence.",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-slate-50 py-8 md:py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-6xl mx-auto">
        {/* Main Product Card */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-blue-50">
          
          {/* Main Container: Image stays on top for mobile, moves to right for desktop */}
          <div className="flex flex-col lg:flex-row-reverse">
            
            {/* Image Section - Adjusted height for mobile */}
            <div className="lg:w-1/2 bg-[#e0f2fe] flex justify-center items-center relative h-64 sm:h-80 lg:h-auto min-h-[300px] lg:min-h-[500px] p-6">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-transparent opacity-50"></div>
              <img
                src={disposable}
                alt="360 Degree Protection"
                className="relative z-10 w-full h-full object-contain max-w-[280px] sm:max-w-sm drop-shadow-2xl transform transition duration-500 hover:scale-105"
              />
            </div>

            {/* Content Section - Adjusted padding for mobile */}
            <div className="lg:w-1/2 p-6 sm:p-10 lg:p-16 flex flex-col justify-center">
              <span className="inline-block w-fit px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-4">
                Maximum Overnight Security
              </span>
              
              <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 leading-tight mb-4 sm:mb-6">
                {/* Total Freedom with <br /> */}
                <span className="text-blue-600">360° Leak Protection</span>
              </h1>

              <p className="text-slate-600 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
                All-around coverage designed for confident movement, day and night. 1 Panty = 5 pads
              </p>

              {/* The "1 = 5" Power Feature - Slimmer on mobile */}
              <div className="mb-8 p-4 sm:p-6 bg-blue-600 rounded-2xl text-white shadow-lg shadow-blue-200 flex items-center justify-between">
                <div className="flex-1">
                  <h3 className="text-xl sm:text-2xl font-bold">The Power of Five</h3>
                  <p className="text-blue-100 opacity-90 text-xs sm:text-sm">
                    Superior absorption in one garment.
                  </p>
                </div>
                <div className="text-2xl sm:text-4xl font-black bg-white text-blue-600 px-3 py-1 sm:px-4 sm:py-2 rounded-xl ml-4">
                  1=5
                </div>
              </div>

              {/* CAROUSEL SECTION */}
              <div className="w-full relative">
                <Swiper
                  modules={[Pagination, Autoplay]}
                  spaceBetween={12}
                  slidesPerView={1}
                  autoplay={{ delay: 3000 }}
                  pagination={{ clickable: true }}
                  breakpoints={{
                    480: { slidesPerView: 1.2 },
                    640: { slidesPerView: 2 },
                  }}
                  className="pb-12" // Space for dots
                >
                  {features.map((feature, idx) => (
                    <SwiperSlide key={idx} className="h-auto">
                      <div className="bg-blue-50 p-4 rounded-2xl border border-blue-100 h-full flex flex-col">
                        <div className="flex items-center gap-2 mb-2">
                          <div className="text-blue-600 bg-white p-1 rounded-lg shadow-sm flex-shrink-0">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              {feature.icon}
                            </svg>
                          </div>
                          <h4 className="font-bold text-slate-800 text-sm sm:text-base ">{feature.title}</h4>
                        </div>
                        <p className="text-xs sm:text-sm text-slate-600 leading-snug">
                          {feature.desc}
                        </p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <Link
               to={activeFlexPath}
                className="mt-4 block w-full text-center px-8 py-4 text-base sm:text-lg font-bold bg-slate-900 hover:bg-slate-800 rounded-xl shadow-lg transition-all duration-300 transform hover:-translate-y-1 active:scale-95 text-white"
              >
                Shop Heavy Flow Comfort
              </Link>
            </div>
          </div>
        </div>

        {/* Comparison Footer */}
        <div className="mt-8 text-center text-slate-400 text-[10px] sm:text-sm px-4">
          <p>
            Ideal for: Heavy Cycles • Postpartum Recovery • Overnight Protection
          </p>
        </div>
      </div>

      <style>{`
        .swiper-pagination-bullet-active {
          background: #2563eb !important; 
          width: 20px;
          border-radius: 4px;
        }
        .swiper-pagination {
          bottom: 0px !important;
        }
      `}</style>
    </div>
  );
};

export default Disposable;